import React, { useContext } from 'react';
// Context
import { FormDataContext } from 'globalState/FormDataContext';
// Components
import Table from 'components/shared/Table/Table';
import ConsentForm from './StepConsentForm';

function StepSummarySection() {
  const [formDataState, formDataDispatch] = useContext(FormDataContext);

  const { firstName, lastName, OtherEnquiry, JobsEnquiry, emailAddress, ContactPhone, Phone } =
    formDataState.formData;

  const setStepInContext = (st) => {
    formDataDispatch({
      type: 'UPDATE_STEP',
      payload: st,
    });
  };

  const title = 'Check your answers';

  /* Table Data */

  // enquiry
  const infoRequested = [];
  if (JobsEnquiry) {
    infoRequested.push(<span>Enquiry</span>);
    infoRequested.push(<span>{JobsEnquiry}</span>);
    infoRequested.push(
      <button
        type="button"
        className="wmcads-btn wmcads-btn--link"
        onClick={() => {
          setStepInContext(3);
        }}
      >
        Change
      </button>
    );
  }

  // name
  const dataLine2 = [];
  dataLine2.push(<span>Name</span>);
  dataLine2.push(<span>{`${firstName} ${lastName}`}</span>);
  dataLine2.push(
    <button
      type="button"
      className="wmcads-btn wmcads-btn--link"
      onClick={() => {
        setStepInContext(4);
      }}
    >
      Change
    </button>
  );

  // contact information
  const dataLine3 = [];
  dataLine3.push(<span>How would you like to be contacted?</span>);
  if (emailAddress !== null && ContactPhone === '') {
    dataLine3.push(
      <span>
        Email
        <br /> {emailAddress}
      </span>
    );
  } else if (emailAddress === '' && ContactPhone) {
    dataLine3.push(
      <span>
        Phone
        <br /> {ContactPhone}
      </span>
    );
  } else if (emailAddress && ContactPhone) {
    dataLine3.push(
      <div>
        <span>
          Email
          <br /> {emailAddress}
        </span>
        <br />
        <br />
        <span>
          Phone
          <br /> {ContactPhone}
        </span>
      </div>
    );
  }

  dataLine3.push(
    <button
      type="button"
      className="wmcads-btn wmcads-btn--link"
      onClick={() => {
        setStepInContext(5);
      }}
    >
      Change
    </button>
  );

  /* End of Table Data */

  const enquiry = [infoRequested];
  const data = [dataLine2, dataLine3];

  if (Phone) {
    data.push(dataLine3);
  }

  const mainTitle = `About your ${OtherEnquiry} enquiry`;

  return (
    <>
      <div className="wmcads-col-1">
        <h2 className="wmcads-fe-question wmcads-m-t-none">{title}</h2>
        <Table
          title={mainTitle}
          classes=""
          cellClasses={['', '', 'wmcads-text-align-right wmcads-p-r-none']}
          headers={[]}
          values={enquiry}
          data-private
        />

        <Table
          title="About you"
          classes=""
          cellClasses={['', '', 'wmcads-text-align-right wmcads-p-r-none']}
          headers={[]}
          values={data}
          data-private
        />

        <h3>Now send your enquiry</h3>
        <p>
          By submitting this enquiry you are confirming that, to the best of your knowledge, the
          details you are providing are correct.
        </p>
        <ConsentForm />
      </div>
    </>
  );
}

export default StepSummarySection;
